import { axiosAjax } from '@app/src/config/axios';
import { YearVehicleModel } from '@app/src/views/StepOne/form/models/yearVehicle';
import { hydrateData } from './hydrators';

export const yearVehicleService = {
  async get(): Promise<YearVehicleModel> {
    try {
      const { data } = await axiosAjax.get(process.env.API_VEHICLE_YEAR);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data[0]);
    } catch (e) {
      throw new Error(e);
    }
  }
}
